<!--
/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software; you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation; either
 * version 2 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with this program;
 * if not, write to the Free Software Foundation, Inc., 51 Franklin Street, Fifth Floor,
 * Boston, MA  02110-1301, USA
 */
 -->

<template>
  <div class="orangehrm-horizontal-padding orangehrm-top-padding">
    <oxd-text tag="h6" class="orangehrm-main-title">
      Edit backup
    </oxd-text>
    <oxd-divider />
    <oxd-form :loading="isLoading" @submitValid="onSave">
      <oxd-form-row>
        <oxd-grid :cols="2" class="orangehrm-full-width-grid">
          <oxd-grid-item>
            <oxd-input-field
              v-model="reportTo.employees"
              value="Select"
              type="select"
              :label="$t('general.active_employees')"
              :options="employees"
              required
              :disabled="true"
            />
          </oxd-grid-item>
          <oxd-grid-item>
            <oxd-input-field
              v-model="reportTo.jobTitle"
              type="select"
              :label="$t('admin.job_titles')"
              :options="jobDescriptions"
            />
          </oxd-grid-item>
        </oxd-grid>
      </oxd-form-row>

      <oxd-form-row>
        <oxd-input-field
          v-model="reportTo.observation"
          type="textarea"
          :label="'Observation'"
          :placeholder="'Type observation here'"
        />
      </oxd-form-row>

      <oxd-form-actions>
        <oxd-button
          type="button"
          display-type="ghost"
          label="Cancel"
          @click="onCancel"
        />
        <submit-button :disabled="isDisabled" />
      </oxd-form-actions>
    </oxd-form>
    <oxd-divider />
  </div>
</template>

<script>
import {
  required,
  validSelection,
  maxFileSize,
  validFileTypes,
  validDateFormat,
  endDateShouldBeAfterStartDate,
} from '@ohrm/core/util/validation/rules';
import usei18n from '@/core/util/composable/usei18n';
import {APIService} from '@/core/util/services/api.service';

// import ReportToEmployeeAutocomplete from '@/orangehrmPimPlugin/components/ReportToEmployeeAutocomplete';

const reportToModel = {
  employees: [],
  jobTitle: null,
  observation: '',
};

const {$t} = usei18n();

export default {
  name: 'EditEmployeeBackups',
  props: {
    http: {
      type: Object,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
  },

  emits: ['close'],

  setup(props) {
    const jobHttp = new APIService(
      window.appGlobal.baseUrl,
      // '/api/v2/admin/job-titles',
      '/api/pim/all-job-titles',
    );

    return {
      jobHttp,
    };
  },

  data() {
    return {
      isLoading: false,
      reportTo: {...reportToModel},
      employees: [],
      jobDescriptions: [],
    };
  },

  computed: {
    isDisabled() {
      if (this.reportTo.employees.length === 0) return true;

      return false;
    },
  },

  mounted() {
    this.reportTo = this.data;
    this.getJobTitles();
  },

  methods: {
    /*
    getEmployees() {
      this.http.request({
        method: 'GET',
        url: `api/v2/pim/employees/${this.empNumber}/get-employees-list`,
      }).then(response => {
        this.employees = response.data;
      })
    },
    */
    getJobTitles() {
      this.jobHttp.getAll().then(({data}) => {
        this.jobDescriptions = data.map(jobDescription => {
          return {
            id: jobDescription.id,
            label: jobDescription.jobTitleName,
          };
        });
      });
    },
    onSave() {
      this.isLoading = true;

      // this.reportTo.empBackupId = this.reportTo.employee.id;

      this.http
        .request({
          method: 'PUT',
          url: `api/v2/pim/employees/${this.empNumber}/backups`,
          data: this.reportTo,
        })
        .then(response => {
          this.$emit('close', true);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    onCancel() {
      this.$emit('close', true);
    },
  },
};
</script>
